var map = require('./map');

    /**
     * Extract a list of property values.
     */
    function pluck(list, key) {
        return map(list, function(value) {
            return value[key];
        });
    }

    module.exports = pluck;





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/pluck.js
// module id = 1577
// module chunks = 0 1 2